import React from 'react';
import { CircularProgress } from '@material-ui/core';
// import Background from "./assets/background_space.svg";
import Background from "./assets/login_background.svg"
import BackgroundMobile from "./assets/login_background_mobile.svg"
import Logo from "../assets/loading/logo_zideeUp.png"
import { withStyles } from '@material-ui/core';
import { withFirebase } from './Firebase';
import "./Loading.css";

const styles = theme => ({
    progress: {
        color: '#ffffff'
    }
})

class Loading extends React.Component {

    async componentDidMount() { }

    render() {
        const { classes } = this.props

        const background = window.innerWidth < 768 ? BackgroundMobile : Background;

        return (
            <div style={{ background: `url(${background}) no-repeat center fixed`, backgroundSize: 'cover', height: '100vh' }}>
                <div className="container">

                    <div className="row logo-container">
                        <div className="col" />
                        <div className="col">
                            <div className="d-flex flex-column align-items-center pt-5">
                                <img className="signin-logo loading-logo" src={Logo} alt="Logo" />
                                <div className="catch-line loading-text">
                                    L'espace amélioration continue
                                </div>
                            </div>
                            <div className="row">
                                <div className="col" />
                                <CircularProgress className={classes.progress} mode="indeterminate" color="secondary" size={75}></CircularProgress>
                                <div className="col" />
                            </div>

                        </div>
                        <div className="col" />
                    </div>

                </div>
            </div>
        )
    }
}

export default withFirebase(withStyles(styles)(Loading));